// extracted by mini-css-extract-plugin
export var addButton = "_nc-0";
export var border = "_nc-8";
export var check = "_nc-h";
export var danger = "_nc-6";
export var dropdownContainer = "_nc-1";
export var editModalBody = "_nc-j";
export var footerContainer = "_nc-i";
export var fullWidth = "_nc-a";
export var hide = "_nc-9";
export var icon = "_nc-3";
export var input = "_nc-7";
export var inputFlex = "_nc-b";
export var inputWrapper = "_nc-c";
export var manualFocus = "_nc-5";
export var optionButton = "_nc-4";
export var pillWrapper = "_nc-e";
export var pointer = "_nc-2";
export var showOverflow = "_nc-f";
export var tagsFlex = "_nc-d";
export var xButton = "_nc-g";